import * as Enumerable from "linq";
import { BaseGhgVerificationRatingFactorClientModel, GhgVerificationCiiFactorClientModel } from "../../../../../models/ghgs/ghg.models";
import { DataType } from "../../../../../models/queries/queries.models";
import { GhgRatingFactorClientModel } from "../../../../../models/vessels/vessel.models";
import { EditableFieldBinding } from "../../../../components/data-grid/data-grid";
import { BaseGhgFactorsRenderer } from "./base-ghg-factors-renderer";
import * as moment from "moment";

export class GhgCiiFactorsRenderer extends BaseGhgFactorsRenderer {
    public ciiRatingYear: Date;
    public todaysDate: Date = moment().toDate();

    public isFactorReadonly(): boolean {
        return false;
    }

    constructor(allCiiFactors: GhgVerificationCiiFactorClientModel[]) {
        super(allCiiFactors);
        this.allFactors.forEach(factor => {
            factor.isVisible = this.showFactor();
        });
    }

    public get orderedFactors(): (BaseGhgVerificationRatingFactorClientModel | GhgRatingFactorClientModel)[] {
        return Enumerable.from(this.allFactors)
            .groupBy(x => x.group)
            .selectMany(x => x)
            .toArray();
    }

    public showGroup() {
        return true;
    }

    public getGroupName(group: string): string {
        return group;
    }

    public getDisplayName(factor: BaseGhgVerificationRatingFactorClientModel | GhgRatingFactorClientModel) {

        if (!factor) {
            return null;
        }

        return factor.displayName;
    }

    public showFactor() {
        return this.showGroup();
    }

    public filtersHtml(factor: (BaseGhgVerificationRatingFactorClientModel | GhgRatingFactorClientModel), propValue: string, isEditable: boolean): string {
        if (factor.propertyName == 'CiiRating') {
            return `
            <div class="cii-ratings row nowrap ${isEditable ? 'is-editable':''}">

                <!-- Rating A -->
                <div class="rating a \${factor.${propValue} == 'A' ? 'is-active' : '' }" click.trigger="ghgCiiFactorsRenderer.setCiiRating(factor, 'A', ${isEditable})">
                    <comp-icon class="icon-cii-rating" icon="cii-rating"></comp-icon>
                    <span class="cii-value">A</span>
                </div>

                <!-- Rating B -->
                <div class="rating b \${factor.${propValue} == 'B' ? 'is-active' : '' }" click.trigger="ghgCiiFactorsRenderer.setCiiRating(factor, 'B', ${isEditable})">
                    <comp-icon class="icon-cii-rating" icon="cii-rating"></comp-icon>
                    <span class="cii-value">B</span>
                </div>

                <!-- Rating C -->
                <div class="rating c \${factor.${propValue} == 'C' ? 'is-active' : '' }" click.trigger="ghgCiiFactorsRenderer.setCiiRating(factor, 'C', ${isEditable})">
                    <comp-icon class="icon-cii-rating" icon="cii-rating"></comp-icon>
                    <span class="cii-value">C</span>
                </div>

                <!-- Rating D -->
                <div class="rating d \${factor.${propValue} == 'D' ? 'is-active' : '' }" click.trigger="ghgCiiFactorsRenderer.setCiiRating(factor, 'D', ${isEditable})">
                    <comp-icon class="icon-cii-rating" icon="cii-rating"></comp-icon>
                    <span class="cii-value">D</span>
                </div>

                <!-- Rating E -->
                <div class="rating e \${factor.${propValue} == 'E' ? 'is-active' : '' }" click.trigger="ghgCiiFactorsRenderer.setCiiRating(factor, 'E', ${isEditable})">
                    <comp-icon class="icon-cii-rating" icon="cii-rating"></comp-icon>
                    <span class="cii-value">E</span>
                </div>
            </div>
            `;
        }

        if (factor.propertyName == "CiiRatingYear" && isEditable) {
            this.ciiRatingYear = factor[propValue] == null ? null : new Date(factor[propValue], 2, 1);
            return `<date-picker placeholder="Date" date.two-way="ghgCiiFactorsRenderer.ciiRatingYear" date-format="YYYY" 
            date-changed.delegate="ghgCiiFactorsRenderer.setCiiRatingYear(factor, ghgCiiFactorsRenderer.ciiRatingYear, ${isEditable})" max-date.bind="ghgCiiFactorsRenderer.todaysDate"></date-picker>`;
        }

        const thirdParameterObj = "12";
        const type = factor.dataType;
        const query = type == DataType.EntityFinder ? 'factor.entityFinderMappedToProperty' : 'factor.lookupMappedToProperty';
        let lookup = null;

        lookup = type == DataType.EntityFinder ? factor.entityFinderMappedToProperty : factor.lookupMappedToProperty;

        const binding: EditableFieldBinding = {
            query: query,
            lookup: lookup,
            isEditable: isEditable,
            binding: "factor." + propValue,
            displayValueBinding: "factor." + propValue,
            value: query,
            dataType: type,
            parameter: "factor." + propValue,
            secondParameter: "",
            isNullable: true,
            buttonDelegate: propValue == "revisedValue" && isEditable ? "ghgCiiFactorsRenderer.onRevisedValueChanged(factor)" : null,
            endLabel: "",
            parameterObj: null,
            secondParameterObj: null,
            thirdParameterObj: thirdParameterObj,
            isValueCollection: false,
            isPropertyCollection: false,
            isNotRangeDatePicker: true
        };

        return this.getControl(binding, true);
    }

    setCiiRating(factor: any, rating: string, isEditable: boolean) {
        if (isEditable) {
            factor.revisedValue = rating;
        }
    }

    setCiiRatingYear(factor: any, date: Date, isEditable: boolean) {
        if (isEditable) {
            factor.revisedValue = moment(date).year();
        }
    }
}